import { render, staticRenderFns } from "./PartAbStatus.vue?vue&type=template&id=2b74c355&lang=pug"
import script from "./PartAbStatus.vue?vue&type=script&lang=js"
export * from "./PartAbStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Anchor: require('/home/docker/code/frontend/components/Anchor.vue').default})
